// extracted by mini-css-extract-plugin
module.exports = {"rawJson":"RenderAuditLogVariables_rawJson__16-Qp","renderAuditLogVariables":"RenderAuditLogVariables_renderAuditLogVariables__2lDt9"};